import { FeatureName } from "@common/ADAPT.Common.Model/embed/feature-name.enum";
import { ImplementationKitService } from "@common/implementation-kit/implementation-kit.service";
import { ImplementationKitArticle } from "@common/implementation-kit/implementation-kit-article.enum";
import { IConfigGroup } from "@org-common/lib/configuration/configuration.interfaces";
import { ConfigArea } from "@org-common/lib/configuration/configuration-types";
import { KanbanAuthService } from "@org-common/lib/kanban/kanban-auth.service";
import { CommonTeamsAuthService } from "@org-common/lib/teams/common-teams-auth.service";

export const allPersonalConfigGroups = (): IConfigGroup[] => [
    {
        key: "Account",
        items: [
            {
                name: "Account login & security",
                area: ConfigArea.AccountSecurity,
            },
        ],
    },
    {
        key: "Personal",
        items: [
            {
                name: "Personal action boards",
                area: ConfigArea.Kanban,
                accessVerifier: KanbanAuthService.EditPersonalStewardshipKanban,
                featureName: FeatureName.StewardshipWorkKanban,
                supportUrl: ImplementationKitService.GetArticleLink(ImplementationKitArticle.UsingKanbanBoards),
                supportText: "Find out more about effective team stewardship in the ADAPT Method",
            },
            {
                name: "Calendar integration",
                accessVerifier: CommonTeamsAuthService.ViewAnyTeamMeeting,
                featureName: FeatureName.StewardshipWorkMeetings,
                area: ConfigArea.CalendarIntegration,
            },
        ],
    }, {
        key: "Notifications",
        items: [
            {
                name: "Activities",
                area: ConfigArea.Notifications,
                accessVerifier: KanbanAuthService.EditPersonalStewardshipKanban,
            },
        ],
    },
];
